import type { IdlAccounts } from '@coral-xyz/anchor'
import { PublicKey } from '@solana/web3.js'
import idlJson from '../idl/forum.json'
import type { Forum } from '../idl/forum'
import { programId } from '../kit/registry.js'
import { solanaCluster } from '../endpoints.js'

// The JSON import widens every literal to `string`/`number[]`; the generated .ts
// carries the exact literal types Anchor wants. Same bytes, two views of them.
export const FORUM_IDL = idlJson as Forum

/**
 * The forum program's address on the cluster this build targets
 * (VITE_SOLANA_CLUSTER), from kit/programs.json — not from the IDL, because
 * the mainnet program gets its own keypair at deploy time and so a different
 * address from localnet/devnet (chain/keys/README.md). A build for a cluster
 * with no recorded address fails here, loudly, instead of reading accounts
 * from the wrong program.
 */
export const FORUM_PROGRAM_ID: PublicKey = programId('forum', solanaCluster)

/**
 * Account shapes as the *program* defines them, derived from the generated IDL.
 * Add or remove a field in the Rust struct and these types change on the next
 * `chain build`, so any code below that used the old shape stops compiling.
 */
export type PublisherAccount = IdlAccounts<Forum>['publisher']
export type VideoAccount = IdlAccounts<Forum>['video']
export type SubtitleTrackAccount = IdlAccounts<Forum>['subtitleTrack']
export type StorageLocationAccount = IdlAccounts<Forum>['storageLocation']
export type VideoContainerAccount = IdlAccounts<Forum>['videoContainer']
export type VersionRefAccount = IdlAccounts<Forum>['versionRef']
